import { useTranslation } from 'react-i18next';

import { ModalComponent } from '@/components/molecules/ModalComponent';

import UserInviteForm, {
    type ExtendedClientInfo,
    type UserInviteFormState,
} from './UserInviteForm';

interface UserInviteModalProps {
    isOpen: boolean;
    onClose: () => void;
    canInviteForOptoscaleAdmin: boolean;
    canInviteForClient: boolean;
    client?: ExtendedClientInfo;
    clients: {
        id: number;
        name: string;
        locations: {
            id: number;
            name: string;
        }[];
    }[];
    onSubmit: (state: UserInviteFormState) => Promise<unknown>;
}

function UserInviteModal({
    isOpen,
    onClose,
    canInviteForOptoscaleAdmin,
    canInviteForClient,
    client,
    clients,
    onSubmit,
}: UserInviteModalProps) {
    const { t } = useTranslation();

    return (
        <ModalComponent
            isOpen={isOpen}
            onClose={onClose}
            size="lg"
            centered={false}
            title={t('userAccess.common.inviteUser')}>
            <UserInviteForm
                client={client}
                clients={clients}
                canInviteForOptoscaleAdmin={canInviteForOptoscaleAdmin}
                canInviteForClient={canInviteForClient}
                onSubmit={onSubmit}
                onCancel={onClose}
                hideBox={true}
            />
        </ModalComponent>
    );
}

export default UserInviteModal;
